import { i18n } from "@/main.js";

export default {
  init: function (app) {
    this.app = app;
    this.lang = app.lang;
    this.insertion = app.insertion;
    this.toolbar = app.toolbar;
    this.templateVariables = [];
    for (const v in app.opts.templateVariables) {
      const variable = {
        title: i18n.t("redactor." + app.opts.templateVariables[v].title),
        args: app.opts.templateVariables[v].args,
        api: app.opts.templateVariables[v].api,
      };
      this.templateVariables.push(variable);
    }
  },
  start: function () {
    // create the button data
    const buttonData = {
      title: i18n.t("redactor.template_variables"),
    };

    // create the button
    const $button = this.toolbar.addButton("template_variables", buttonData);

    // set dropdown
    $button.setDropdown(this.templateVariables);
  },
  insertVar: function (variable) {
    this.insertion.insertRaw(" " + variable + " ");
  },
};
